module.exports = __webpack_public_path__ + "img/qualifications5.677ec6b8.png";